import request from '../../util/request'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
import { config } from '../../config/config'

/**
 * 自定义接口 --- 对应 后端接口管理
 */
export default class customApi extends alertUtils {
  /**
   * 获取当前应用下可以看到的所有接口
   * @param id  表单ID
   */
  static getDataInterface(id) {
    if (formUtils.isNull(id)) {
      this.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/interface/getDataInterface?id=' + id,
      method: 'get',
    })
  }

  /**
   * 获取接口 详细
   * @param id  接口ID
   */
  static getDataInterfaceInfo(id) {
    if (formUtils.isNull(id)) {
      this.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/interface/getDataInterfaceInfo?id=' + id,
      method: 'get',
    })
  }

  /**
   *  根据接口ID，查询接口数据
   * @param id 接口ID
   */
  static requestInterface(id, queryParams) {
    if (formUtils.isNull(id)) {
      this.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url:
        config.baseAPI +
        '/v1/interface/requestInterface?id=' +
        id +
        '&queryParams=' +
        encodeURIComponent(JSON.stringify(queryParams)),
      method: 'get',
    })
  }
}
